// extracted by mini-css-extract-plugin
export default {"header":"Header_header__FE5Vg","esquerda":"Header_esquerda__kdGIY","direita":"Header_direita__+Rxrt","sacola":"Header_sacola__GzDAK","usuario":"Header_usuario__V-Iqh"};